// import { useEffect, useState } from "react";
import { Box } from "@mui/material";
import RevaText from "components/common/RevaText";
import { useHistory } from "react-router-dom";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import { styled } from "@mui/material/styles";
import { FormattedDate, useIntl } from "react-intl";
import esLocale from "@fullcalendar/core/locales/es";
import enLocale from "@fullcalendar/core/locales/en-gb";

const localeMap = {
  es: esLocale,
  en: enLocale,
};

const StyledCalendarWrapper = styled("div")(({ theme }) => ({
  // Sobrescribimos el borde de los eventos
  "& .fc-h-event": {
    border: "none",
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.common.white,
    fontWeight: 500,
    fontSize: 14,
    transition: "background-color 0.25s ease-in-out", // 💫 transicion suave
  },

  // Mejorar hover
  "& .fc-h-event:hover": {
    backgroundColor: theme.palette.secondary.dark,
  },
}));

export default function OrganizationCalendar({ competitions = [] }) {
  const history = useHistory();
  const { locale } = useIntl();
  // Transformar competencias → eventos para FullCalendar
  const calendarEvents = competitions.map((competition) => {
    return {
      id: competition.id,
      title: competition.name,
      start: competition.start_date,
      end: competition.end_date || competition.start_date, // por si tenés un rango
      //   url: `/tournament/${tournament.id}`, // o deep link
      extendedProps: {
        competitionName: competition.name,
        competitionUuid: competition.uuid_,
      },
    };
  });

  function renderEventContent(eventInfo) {
    return (
      <Box sx={{ p: 1 }}>
        <div>{eventInfo.event.title}</div>
        <div style={{ fontSize: 10, opacity: 0.8 }}>
          <FormattedDate value={new Date(eventInfo.event.start)} month="long" day="numeric" />
          {" - "}
          <FormattedDate value={new Date(eventInfo.event.end)} year="numeric" month="long" day="numeric" />
        </div>
      </Box>
    );
  }

  return (
    <StyledCalendarWrapper>
      <RevaText variant="h5" id="Calendario de torneos" />
      <FullCalendar
        plugins={[dayGridPlugin]}
        initialView="dayGridMonth"
        events={calendarEvents}
        eventContent={renderEventContent}
        contentHeight={500}
        locales={[esLocale, enLocale]}
        locale={localeMap[locale] || "en"}
        eventClick={(info) => {
          console.log();
          const competitionUuid = info.event.extendedProps.competitionUuid;
          if (competitionUuid) history.push(`/event/${competitionUuid}`);
        }}
      />
    </StyledCalendarWrapper>
  );
}
